import React, { Dispatch, SetStateAction, useContext } from 'react'
import BGModal from '../../assets/modalBG.svg'
import closeModalIcon from '../../assets/closeBlue.svg'
import { BeneficiaryType } from 'types/beneficiary'
import imageTransferArgent from '../../assets/imageTransferArgent.svg'
import imageRechargeMobile from '../../assets/imageRechargeMobile.svg'
import imageTransferWalletSenegal from '../../assets/imageTransferWallet.svg'
import imageTransferBancaire from '../../assets/imageTransferBancaire.svg'
import imagePaimentFacture from '../../assets/imagePaimentFacture.svg'
import { useNavigate } from 'react-router-dom'
import transferBeneficiaryContext from 'contexts/transferBeneficiaryContext'
import RechargeContext from 'contexts/rechargeContext'
import Avatar from 'components/avatar'
type BeneficiaryAction = 'delete' | 'update' | 'service' | null

interface Props {
  selectedBeneficiary: BeneficiaryType
  setAction: any | Dispatch<SetStateAction<BeneficiaryAction>>
  // setAction?: Dispatch<SetStateAction<BeneficiaryAction>>
}
const COUNTRY_MAP: Record<string, string> = {
  '216': 'TND',
  '221': 'XOF',
  '212': 'MAD',
  '92': 'PKR',
  '880': 'BDT',
  '90': 'TRY',
  '234': 'NGN',
  '254': 'KES',
  '63': 'PHP',
}

const serviceList = [
  {
    icon: imageTransferArgent,
    transaction: 'Transfert avec retrait cash',
    color: 'bg-[#5754E5] hover:bg-[#4D36CC]',
    navigate: '/transfert/0',
    // Enabled: ['TND', 'MAD','PKR', 'BDT']
    Enabled: ['216', '212', '92', '880'],
  },
  {
    icon: imageTransferBancaire,
    transaction: 'Transfert de compte à compte ',
    color: 'bg-[#20C374] hover:bg-[#1DB069]',
    navigate: '/transfert/1',
    // Enabled: ['TND', 'MAD','PKR','TRY','NGN','XOF','PHP', 'KES']
    Enabled: ['216', '212', '92', '90', '234', '221', '63', '254'],
  },
  {
    icon: imageRechargeMobile,
    transaction: 'Recharge mobile',
    color: 'bg-[#FFC000] hover:bg-[#E6AD00]',
    navigate: '/recharge',
    Enabled: ['all'],
  },
  {
    icon: imageTransferWalletSenegal,
    transaction: 'Transfert vers Wallet',
    color: 'bg-[#B28858] hover:bg-[#9D7241]',
    navigate: '/transfert-vers-wallet',
    // Enabled: ['XOF', 'XOF', 'KES', 'PHP', 'PKR']
    Enabled: ['221', '254', '63', '92'],
  },
  {
    icon: imagePaimentFacture,

    transaction: 'Paiement de factures locales',
    color: 'bg-[#38C3FF] hover:bg-[#33B0E6]',
    navigate: '/paimentFacture',
  },
]

const ModalBeneficiaryServices: React.FC<Props> = ({ selectedBeneficiary, setAction }) => {
  const { setTransferData } = useContext(transferBeneficiaryContext)
  const { setRecharges } = useContext(RechargeContext)
  const phonePrefix = selectedBeneficiary.personalInfo.phone.prefix
  const paysValue = COUNTRY_MAP[phonePrefix]
  const navigate = useNavigate()

  const handleServiceNavigation = (path: string) => {
    if (path === '/recharge') {
      setRecharges({
        phoneNumber: selectedBeneficiary.personalInfo.phone.number,
        prefix: `${'+'}${phonePrefix}`,
      })
    } else {
      setTransferData({
        BeneficiaryName: `${selectedBeneficiary.personalInfo?.firstName} ${selectedBeneficiary.personalInfo?.lastName}`,
        idBeneficiary: selectedBeneficiary._id,
        bankcode: selectedBeneficiary.bankCode,
        swiftBic: selectedBeneficiary.SWIFTBIC,
        banqueName: selectedBeneficiary.bankName,
        numBankBeneficiary: selectedBeneficiary.accountNumber,
        cinBeneficiary: selectedBeneficiary.identifiantCardNumber,
        phoneNumberBeneficiary: `${selectedBeneficiary.personalInfo?.phone.prefix} ${selectedBeneficiary.personalInfo?.phone.number} `,
        currentPath: '/beneficiary',
        valuePays: paysValue,
        avatar: selectedBeneficiary.avatar,
      })
    }
    navigate(path)
  }
  return (
    <div className=" flex flex-col fixed justify-center place-items-center z-20  inset-0  shadow-inner bg-[rgba(87,84,229,0.6)] backdrop-blur-[5px] w-full">
      <div className=" -mb-[28px]  rounded-full shadow-xl border-white border-[5px] object-cover">
        <Avatar styleCss="w-[88px] h-[88px]" avatar={selectedBeneficiary.avatar} />
      </div>

      <img src={BGModal} width={327} height={78} alt="" />
      <div className=" relative w-[327px]  rounded-b-[16px] px-5  flex flex-col items-center  shadow-[0px_4px_10px, rgba(0,0,0,0.25)] bg-white">
        <img
          src={closeModalIcon}
          width={24}
          height={24}
          onClick={() =>{
            setAction(null) 
          } 
          
        }
          className="absolute right-6 -top-12 w-[28px] hover:cursor-pointer sm:w-[24px] "
        />
        <h3 className="h2">
          {selectedBeneficiary.personalInfo.lastName} {selectedBeneficiary.personalInfo.firstName}{' '}
        </h3>
        <div className="text-[#5754E5]/30 text-[14px] ">
          {' '}
          {'+'}
          {phonePrefix} {selectedBeneficiary.personalInfo.phone.number}{' '}
        </div>
        <div className="flex flex-col gap-4 w-full mt-6 mb-12 ">
          {serviceList.map((item) => (
            <div
              key={item.navigate}
              onClick={() => 
                {handleServiceNavigation(item.navigate)
                setAction(null)

                }

              }
              className={`${item.color}
                ${
                  item.Enabled?.includes('all') || item.Enabled?.includes(phonePrefix)
                    ? 'p-4 w-full h-[56px] rounded-[10px] text-white flex gap-3 items-center cursor-pointer'
                    : 'hidden'
                } `}
            >
              <img src={item.icon} width={43} height={43} alt={item.transaction} />
              <h2 className="font-bold leading-5">{item.transaction}</h2>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ModalBeneficiaryServices
